import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AlertApi } from '../../../apis/AlertApi/AlertApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';

export function useMarkAllPatientAlertsVisited() {
    const queryClient = useQueryClient();

    return useMutation<void, AppMedError, void>({
        mutationKey: [QueryKeys.patientAlerts, 'visitAll'],
        mutationFn: async () => {
            return await AlertApi.visitAllPatientAlerts();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.patientAlerts] });
        },
    });
}
